import {
  Heading,
  HStack,
  VStack,
  Text,
  Divider,
  Square,
  Image,
  Box,
  LinkBox,
  LinkOverlay,
  Flex,
  Link,
  Avatar,
  Spinner
} from '@chakra-ui/react'
import moment from 'moment'
import React, { FC, useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { DashboardLayout } from '../components'
import { ROUTES } from '../contants'
import useDashboardStore from '../state/Dashboard.store'
import { money, titleCase } from '../utils/formatter'
import { IPolicy } from '../types'

const Dashboard = () => {
  const { first_name, last_name } = JSON.parse(localStorage.getItem('auth') || '')?.user
  const [
    dashboardLoading,
    quotes,
    policies,
    getDashboardData,
    quotePageInfo,
    policyPageInfo,
    expiry,
    expired
  ] = useDashboardStore((state) => [
    state.dashboardLoading,
    state.quotes,
    state.policies,
    state.getDashboardData,
    state.quotePageInfo,
    state.policyPageInfo,
    state.expiry,
    state.expired
  ])

  useEffect(() => {
    getDashboardData()
  }, [getDashboardData])

  return (
    <DashboardLayout dashboard>
      {dashboardLoading === 'loading' ? (
        <VStack h="100%" justify="center" flex={1}>
          <Spinner size="xl" />
        </VStack>
      ) : dashboardLoading === 'success' || dashboardLoading === 'updating' ? (
        <>
          <HStack justify="space-between">
            <HStack spacing="1.6rem">
              <Avatar size="lg" name={`${last_name} ${first_name} `} />
              <Heading fontSize="1.6rem" fontWeight="600" color="black">
                Hi, {titleCase(first_name)}
              </Heading>
            </HStack>

            {/* <Link
              to={ROUTES.notifications}
              as={RouterLink}
              color="brand.blue"
              fontSize="1.2rem"
              _hover={{ border: 'none', outline: 'none' }}
              _active={{ border: 'none', outline: 'none' }}
              _focus={{ border: 'none', outline: 'none' }}>
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 15H20V17H0V15H2V8C2 5.87827 2.84285 3.84344 4.34315 2.34315C5.84344 0.842855 7.87827 0 10 0C12.1217 0 14.1566 0.842855 15.6569 2.34315C17.1571 3.84344 18 5.87827 18 8V15ZM16 15V8C16 6.4087 15.3679 4.88258 14.2426 3.75736C13.1174 2.63214 11.5913 2 10 2C8.4087 2 6.88258 2.63214 5.75736 3.75736C4.63214 4.88258 4 6.4087 4 8V15H16ZM7 19H13V21H7V19Z"
                  fill="black"
                />
              </svg>
            </Link> */}
          </HStack>
          <HStack mt="1.6rem" py="2.7rem" rounded="0.8rem" bg="brand.blue" color="white">
            <HStack justify="center" flex="1" spacing="1.2rem">
              <svg
                width="24"
                height="31"
                viewBox="0 0 24 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.044 3.26816L12 0.833496L22.956 3.26816C23.2521 3.33398 23.5169 3.49878 23.7067 3.73537C23.8965 3.97196 23.9999 4.26618 24 4.5695V17.8855C23.9999 19.2025 23.6747 20.4991 23.0532 21.6602C22.4317 22.8213 21.5332 23.811 20.4373 24.5415L12 30.1668L3.56267 24.5415C2.46703 23.8111 1.56861 22.8216 0.947131 21.6608C0.325648 20.4999 0.000315142 19.2036 0 17.8868V4.5695C5.20504e-05 4.26618 0.103517 3.97196 0.293319 3.73537C0.483122 3.49878 0.747916 3.33398 1.044 3.26816ZM2.66667 5.63883V17.8855C2.66668 18.7634 2.88343 19.6278 3.29768 20.4019C3.71193 21.176 4.31087 21.8358 5.04133 22.3228L12 26.9628L18.9587 22.3228C19.6889 21.8359 20.2878 21.1763 20.702 20.4025C21.1162 19.6286 21.3331 18.7645 21.3333 17.8868V5.63883L12 3.56683L2.66667 5.63883ZM13.3333 12.8335H17.3333L10.6667 22.1668V15.5002H6.66667L13.3333 6.16683V12.8335Z"
                  fill="white"
                />
              </svg>
              <VStack spacing={0} align="flex-start">
                <Heading fontWeight="600">{policyPageInfo?.total}</Heading>
                <Text fontSize="1.2rem">Policies</Text>
              </VStack>
            </HStack>
            <Divider orientation="vertical" />
            <HStack justify="center" flex="1" spacing="1.2rem">
              <svg
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M25.9994 0.5C26.7354 0.5 27.3327 1.09733 27.3327 1.83333V20.5C27.3327 21.236 26.7354 21.8333 25.9994 21.8333H6.60602L0.666016 26.5V1.83333C0.666016 1.09733 1.26335 0.5 1.99935 0.5H25.9994ZM24.666 3.16667H3.33268V21.0133L5.68335 19.1667H24.666V3.16667ZM12.0194 6.38267L12.6153 7.3C10.3913 8.504 10.43 10.436 10.43 10.852C10.6367 10.8253 10.854 10.82 11.07 10.84C12.2727 10.952 13.2207 11.94 13.2207 13.1667C13.2207 14.4547 12.1754 15.5 10.8874 15.5C10.1714 15.5 9.48735 15.1733 9.05535 14.7133C8.36868 13.9853 7.99935 13.1667 7.99935 11.84C7.99935 9.50667 9.63668 7.416 12.0194 6.38267ZM18.686 6.38267L19.282 7.3C17.058 8.504 17.0967 10.436 17.0967 10.852C17.3034 10.8253 17.5207 10.82 17.7367 10.84C18.9394 10.952 19.8874 11.94 19.8874 13.1667C19.8874 14.4547 18.842 15.5 17.554 15.5C16.838 15.5 16.154 15.1733 15.722 14.7133C15.0354 13.9853 14.666 13.1667 14.666 11.84C14.666 9.50667 16.3034 7.416 18.686 6.38267Z"
                  fill="white"
                />
              </svg>

              <VStack spacing={0} align="flex-start">
                <Heading fontWeight="600">{quotePageInfo?.total}</Heading>
                <Text fontSize="1.2rem">Quotes </Text>
              </VStack>
            </HStack>
          </HStack>
          {expired ? (
            <LinkBox
              as={HStack}
              mt="0.8rem"
              color="brand.blue"
              py="0.8rem"
              px="1.8rem"
              justify="space-between"
              rounded="0.8rem"
              bg="rgba(255, 27, 27, 0.1)">
              <HStack spacing="1rem">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.66576 12.3335V8.3335C1.66576 6.91901 2.22766 5.56245 3.22786 4.56226C4.22805 3.56207 5.58461 3.00016 6.99909 3.00016C8.41358 3.00016 9.77013 3.56207 10.7703 4.56226C11.7705 5.56245 12.3324 6.91901 12.3324 8.3335V12.3335H12.9991V13.6668H0.999094V12.3335H1.66576ZM2.99909 8.3335H4.33243C4.33243 7.62625 4.61338 6.94798 5.11348 6.44788C5.61357 5.94778 6.29185 5.66683 6.99909 5.66683V4.3335C5.93823 4.3335 4.92081 4.75492 4.17067 5.50507C3.42052 6.25521 2.99909 7.27263 2.99909 8.3335ZM6.33243 0.333496H7.66576V2.3335H6.33243V0.333496ZM12.1844 2.2055L13.1271 3.14816L11.7138 4.56216L10.7704 3.6195L12.1844 2.2055ZM0.871094 3.14816L1.81376 2.2055L3.22776 3.61883L2.28576 4.56283L0.871094 3.14816Z"
                    fill="#FF1B1B"
                  />
                </svg>
                <LinkOverlay color="#FF1B1B" fontSize="1rem" as={RouterLink} to="/policies">
                  {expired} Expired Policy. Renew now.
                </LinkOverlay>
              </HStack>
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.97656 6.00011L0.851562 1.87511L2.0299 0.696777L7.33323 6.00011L2.0299 11.3034L0.851562 10.1251L4.97656 6.00011Z"
                  fill="#FF1B1B"
                />
              </svg>
            </LinkBox>
          ) : expiry?.page_info?.total ? (
            <LinkBox
              as={HStack}
              mt="0.8rem"
              color="brand.blue"
              py="0.8rem"
              px="1.8rem"
              justify="space-between"
              rounded="0.8rem"
              bg="rgba(253, 128, 57, 0.15)">
              <HStack spacing="1rem">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.66576 12.3335V8.3335C1.66576 6.91901 2.22766 5.56245 3.22786 4.56226C4.22805 3.56207 5.58461 3.00016 6.99909 3.00016C8.41358 3.00016 9.77013 3.56207 10.7703 4.56226C11.7705 5.56245 12.3324 6.91901 12.3324 8.3335V12.3335H12.9991V13.6668H0.999094V12.3335H1.66576ZM2.99909 8.3335H4.33243C4.33243 7.62625 4.61338 6.94798 5.11348 6.44788C5.61357 5.94778 6.29185 5.66683 6.99909 5.66683V4.3335C5.93823 4.3335 4.92081 4.75492 4.17067 5.50507C3.42052 6.25521 2.99909 7.27263 2.99909 8.3335ZM6.33243 0.333496H7.66576V2.3335H6.33243V0.333496ZM12.1844 2.2055L13.1271 3.14816L11.7138 4.56216L10.7704 3.6195L12.1844 2.2055ZM0.871094 3.14816L1.81376 2.2055L3.22776 3.61883L2.28576 4.56283L0.871094 3.14816Z"
                    fill="#2E279D"
                  />
                </svg>
                <LinkOverlay fontSize="1rem" as={RouterLink} to="/policies">
                  Policies Expiring in 7 Days!
                </LinkOverlay>
              </HStack>
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.97656 6.00011L0.851562 1.87511L2.0299 0.696777L7.33323 6.00011L2.0299 11.3034L0.851562 10.1251L4.97656 6.00011Z"
                  fill="#2E279D"
                />
              </svg>
            </LinkBox>
          ) : null}
          {policies?.length ? (
            <VStack mt="2.7rem" justify="flex-start" align="flex-start" spacing="1rem">
              <HStack w="full" justify="space-between">
                <Heading fontWeight="400" fontSize="1.4rem">
                  My Policies{' '}
                </Heading>
                <Link
                  to={ROUTES.policies.base}
                  as={RouterLink}
                  color="brand.blue"
                  fontSize="1.2rem"
                  _hover={{ border: 'none', outline: 'none' }}
                  _active={{ border: 'none', outline: 'none' }}
                  _focus={{ border: 'none', outline: 'none' }}>
                  View All
                </Link>
              </HStack>
              {policies?.slice(0, 3).map((policy: IPolicy) => (
                <Detail
                  key={policy.id}
                  image={policy.policy_type === 'vehicle' ? 'car' : 'gadget'}
                  title={
                    policy[policy.policy_type].make
                      ? `${policy[policy.policy_type].make} ${policy[policy.policy_type].model}`
                      : `${policy[policy.policy_type].model}`
                  }
                  id={policy.id}
                  status={policy.policy_status}
                  body={policy.product.name}
                  expiry={policy.expiration_date}
                />
              ))}
            </VStack>
          ) : null}
          {quotes?.length ? (
            <>
              <HStack mt="2.7rem" w="full" justify="space-between">
                <Heading fontWeight="400" fontSize="1.4rem">
                  My Quotes{' '}
                </Heading>
                <Link
                  to={ROUTES.quotes.base}
                  as={RouterLink}
                  color="brand.blue"
                  fontSize="1.2rem"
                  _hover={{ border: 'none', outline: 'none' }}
                  _active={{ border: 'none', outline: 'none' }}
                  _focus={{ border: 'none', outline: 'none' }}>
                  View All
                </Link>
              </HStack>
              <HStack mt="1.2rem" spacing="1rem" overflow="scroll">
                {quotes?.map((quote: IPolicy) => (
                  <BuyBox
                    key={quote.id}
                    id={quote.id}
                    time={quote.product.period}
                    src={`/images/buy-${quote.policy_type === 'vehicle' ? 'car' : 'gadget'}.png`}
                    amount={quote.amount}
                    title={`${quote.policy_type === 'gadget' ? 'Gadget' : 'Motor'} Insurance`}
                    description={quote.product.name}
                  />
                ))}{' '}
              </HStack>
            </>
          ) : null}
        </>
      ) : null}
    </DashboardLayout>
  )
}

export { Dashboard }

type Props = {
  image: string
  title: string
  body: string
  status: string
  expiry: any
  id: string
}
const Detail: FC<Props> = ({ image, title, body, status, expiry, id }) => {
  status = status.toLowerCase()

  return (
    <LinkBox
      as={HStack}
      w="100%"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.04)"
      borderRadius="1.2rem"
      p="0.8rem"
      bg="white">
      <Square mr="1.2rem" size="4rem" bg="#F7F7F7">
        <Image src={`/images/${image}.svg`} />
      </Square>
      <VStack align="flex-start">
        <Text color="black" fontWeight="500" fontSize="1.2rem">
          {title}
        </Text>
        <LinkOverlay fontSize="1rem" as={RouterLink} to={`/policies/${id}`}>
          {body}
        </LinkOverlay>
      </VStack>
      <HStack justify="flex-end" alignSelf="flex-start" flex="1">
        <Text
          textTransform="capitalize"
          color={
            status === 'approved'
              ? moment.duration(moment(expiry).diff(moment()), 'milliseconds').asDays() > 0
                ? '#0AB86F'
                : '#FF1B1B'
              : status === 'pending'
              ? 'rgba(253, 128, 57, 0.99)'
              : '#FF1B1B'
          }
          textAlign="right"
          display="flex"
          alignItems="center"
          fontSize="1rem">
          {status === 'approved' ? (
            moment.duration(moment(expiry).diff(moment()), 'milliseconds').asDays() > 0 ? (
              <>
                <svg
                  width="10"
                  style={{ marginRight: '5px' }}
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.99914 7.5L2.06014 9.295L2.85914 5.945L0.244141 3.705L3.67664 3.43L4.99914 0.25L6.32164 3.43L9.75464 3.705L7.13914 5.945L7.93814 9.295L4.99914 7.5Z"
                    fill="#0AB86F"
                  />
                </svg>
                Active
              </>
            ) : (
              'Expired'
            )
          ) : (
            titleCase(status)
          )}
        </Text>
      </HStack>
    </LinkBox>
  )
}

type NProps = {
  title: string
  description: string
  src: string
  amount: number
  time: string
  id: string
}

const BuyBox: FC<NProps> = ({ title, description, src, amount, time, id }) => {
  return (
    <LinkBox
      as={VStack}
      pos="relative"
      border="1px solid #F7F7F7"
      borderRadius="1.6rem"
      overflow="hidden"
      minW="140px"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.08)">
      <Box bgPos="center" backgroundSize="cover !important" w="100%" bg={`url(${src})`} h="100px" />
      <Box w="100%" p="1.2rem">
        <Heading fontWeight="500" color="black" fontSize="1.2rem">
          {title}
        </Heading>
        <LinkOverlay fontSize="1rem" as={RouterLink} to={`/quotes/${id}`}>
          {description}
        </LinkOverlay>
        <Heading
          mt="1.9rem"
          fontSize="1.4rem"
          lineHeight="1"
          d="flex"
          alignItems="flex-end"
          color="brand.blue">
          {money(amount)}
          {'  '}
          <Text lineHeight="1" fontSize="1.1rem" fontWeight="400" as="span">
            / {time}
          </Text>
        </Heading>
      </Box>
    </LinkBox>
  )
}
